import { resolveProfilePictureUrl } from '@wlb/shared/utils/imageUrl';
import { resolveProfileUserGuidFromRecord } from '@wlb/shared/utils/navigateToUserProfile';
import type { UserConnectionItem } from '@wlb/shared/types/userProfile';
import { getUsernameDisplay } from '../../../utils/usernameDisplay';

/** The label the API row is known by: username, then legacy name, then id. */
export const connectionDisplayName = (user: UserConnectionItem): string =>
  getUsernameDisplay(user, String(user.userId));

export const connectionAvatarUrl = (user: UserConnectionItem): string =>
  resolveProfilePictureUrl(user.userPhoto) ?? '';

/**
 * The GUID the profile route needs. Rows spell it `profileUserGuid` or
 * `userGuid` depending on the relation the API answered, and a numeric id or
 * the visible username never opens a profile.
 */
export const connectionProfileGuid = (user: UserConnectionItem): string | null =>
  resolveProfileUserGuidFromRecord(user as unknown as Record<string, unknown>);
